import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import FAQManager from './App.js';
import './styles/globals.css';

// posthog.init('phc_cZyENAslEHTUNXMWgnXbTwdYEGPrET1EXkbmya8Jw7r', {
//   api_host: 'https://app.posthog.com',
//   loaded: (posthog) => {
//     //if (process.env.NODE_ENV === 'development') posthog.debug();
//   }
// });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FAQManager />
  </React.StrictMode>
);